import React, { useEffect, useState } from 'react';

import './styles.css';

import { useHistory } from 'react-router';

import coachServices from '../../../services/academy/coachServices';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import Input from '../../../components/Input';
import cepServices from '../../../services/cepServices';

function NewCoach(props) {
    const history = useHistory();
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [photo, setPhoto] = useState(null);
    const [postalCode, setPostalCode] = useState('');
    const [addressState, setAddressState] = useState('');
    const [city, setCity] = useState('');
    const [address, setAddress] = useState('');
    const [district, setDistrict] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [iso2, setIso2] = useState('');
    const [dialCode, setDialCode] = useState('');
    const [phone, setPhone] = useState('');
    const [isValidNumber, setIsValidNumber] = useState('');
    const [gender, setGender] = useState('');
    const dateNow = new Date();
    const [birth, setBirth] = useState(`${dateNow.getFullYear()}-${String(dateNow.getMonth() + 1).padStart(2, '0')}-${String(dateNow.getDate()).padStart(2, '0')}`);

    const [isAdmin, setIsAdmin] = useState(false);



    function verifyIsAdmin() {
        setIsAdmin(props.history.location.pathname.includes("admin"));

    }

    useEffect(() => {
        verifyIsAdmin();
    }, [])

    async function createCoach() {
        console.log(name);
        console.log(surname);
        console.log(photo);
        console.log(postalCode);
        console.log(addressState);
        console.log(city);
        console.log(address);
        console.log(district);
        console.log(email);
        console.log(password);
        console.log(iso2);
        console.log(dialCode);
        console.log(phone);
        console.log(birth);
        if (email && password && confirmPassword && name && surname && gender && birth && iso2 && dialCode && phone && address && city && district && addressState && postalCode) {
            if (isValidNumber) {
                if (password === confirmPassword) {
                    const response = await coachServices.postCoach(email, password, name, surname, gender[0], birth, iso2, dialCode, phone, address, city, district, addressState, postalCode, photo);
                    if (response.status === 201)
                        history.goBack();
                    else
                        alert("Erro ao criar novo professor, tente novamente!");
                } else
                    alert("A confirmação de senha não corresponde à senha digitada, tente novamente!");
            } else
                alert(`O número de telefone ${phone} não é válido, tente novamente!`);
        } else
            alert("Preencha os dados obrigatórios*");
    }

    async function getCepInfo() {
        try {
            if(postalCode === "")
                return;
            const response = await cepServices.getCepInfo(postalCode);
            if(response.data.erro)
                alert("Não foi possível encotrar o CEP informado.");
            else {
                setCity(response.data.localidade);
                setAddress(response.data.logradouro);
                setDistrict(response.data.bairro);
                setAddressState(response.data.uf);
            }
        } catch(err) {

            alert("CEP Inválido.");
        }
    }

    useEffect(() => {
        if(postalCode.length === 8)
            getCepInfo();

    }, [postalCode]);

    return (
        <MainView currentPage={isAdmin ? "academies" : 'coaches'} adminMenu={isAdmin}>
            <NavHistory navPages={["Professores", "Cadastrar"]} />
            <form className='new-coach-page-form' action="">
                <h4>Cadastro de professor</h4>
                <Input
                    label='Nome*'
                    placeholder="Nome"
                    id='new-coach-form-name'
                    onChange={(event) => setName(event.target.value)}
                    value={name}
                />
                <Input
                    label='Sobrenome*'
                    placeholder="Sobrenome"
                    id='new-coach-form-surname'
                    onChange={(event) => setSurname(event.target.value)}
                    value={surname}
                />
                <Input
                    type='select'
                    noFilterOptions
                    options={['Feminino', 'Masculino']}
                    label='Gênero*'
                    id='new-coach-form-gender'
                    onChange={(event) => setGender(event.target.value)}
                    value={gender}
                />
                <Input
                    label='Data de nascimento*'
                    type='date'
                    placeholder="Data de nascimento"
                    id='new-coach-form-birth'
                    onChange={(event) => setBirth(event.target.value)}
                    value={birth}
                />
                <Input
                    label='Foto de perfil'
                    type='photo'
                    accept="image/*"
                    placeholder="Selecione uma foto"
                    showFileLabel
                    filePreview
                    className='new-coach-form-file-input'
                    id='new-coach-form-photo'
                    onChange={setPhoto}
                    value={photo ? URL.createObjectURL(photo) : ''}
                />
                <Input
                    label='Código postal (CEP)*'
                    placeholder="Código postal"
                    id='new-coach-form-postal-code'
                    onChange={(event) => setPostalCode(String(event.target.value).replace(/\D/g, ''))}
                    value={postalCode}
                    //onBlur={getCepInfo}
                />
                <Input
                    label='Estado*'
                    placeholder="Estado"
                    id='new-coach-form-state'
                    onChange={(event) => setAddressState(event.target.value)}
                    value={addressState}
                />
                <Input
                    label='Cidade*'
                    placeholder="Cidade"
                    id='new-coach-form-city'
                    onChange={(event) => setCity(event.target.value)}
                    value={city}
                />
                <Input
                    label='Endereço*'
                    placeholder="Endereço"
                    id='new-coach-form-address'
                    onChange={(event) => setAddress(event.target.value)}
                    value={address}
                />
                <Input
                    label='Bairro*'
                    placeholder="Bairro"
                    id='new-coach-form-district'
                    onChange={(event) => setDistrict(event.target.value)}
                    value={district}
                />
                <Input
                    label='Telefone*'
                    type='tel'
                    placeholder="Telefone"
                    id='new-coach-form-phone'
                    onChange={(event) => setPhone(event.target.value)}
                    setIso2={setIso2}
                    setDialCode={setDialCode}
                    setIsValidNumber={setIsValidNumber}
                    value={phone}
                />
                <Input
                    label='Email*'
                    type='email'
                    placeholder="Email"
                    id='new-coach-form-email'
                    onChange={(event) => setEmail(event.target.value)}
                    value={email}
                />
                <Input
                    label='Senha*'
                    placeholder="Senha"
                    id='new-coach-form-password'
                    onChange={(event) => setPassword(event.target.value)}
                    value={password}
                />
                <Input
                    label='Confirmação de senha*'
                    placeholder="Confirme a senha"
                    id='new-coach-form-confirm-password'
                    onChange={(event) => setConfirmPassword(event.target.value)}
                    value={confirmPassword}
                />
                <button type='button' onClick={createCoach}>Cadastrar professor</button>
            </form>
        </MainView>

    )
}

export default NewCoach;